import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_health_conditions } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchHealthConditions = async (
  setHealthConditions,
  baseUrl,
  prodTestUrl
) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch_health_conditions();
    if (response.statusText=="OK") {
      const data = response?.data;
      setHealthConditions(data);
    } else {
      message.error("Failed to fetch health conditions.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching health conditions.");
  }
};
